import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { api } from '@/lib/api';
import { ProductCard } from '@/components/ProductCard';

export default function Wishlist() {
  const [products, setProducts] = useState(null);

  useEffect(() => { api.get('/wishlist').then(({ data }) => setProducts(data)); }, []);

  return (
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 lg:py-24">
      <p className="eyebrow mb-3">Saved for later</p>
      <h1 className="font-serif text-4xl lg:text-6xl mb-12 flex items-center gap-4">
        <Heart className="text-gold fill-gold" size={38} /> Your Wishlist
      </h1>
      {products === null ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : products.length === 0 ? (
        <div className="text-center py-20">
          <Heart size={40} className="mx-auto mb-4 text-muted-foreground opacity-40" />
          <p className="text-muted-foreground mb-6">You haven't saved any pieces yet.</p>
          <Link to="/shop" className="bg-gold text-primary-foreground px-6 py-3 text-xs font-mono uppercase tracking-widest hover:bg-gold-hover">Browse the Collection</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-testid="wishlist-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
